import React from "react";
import T from "prop-types";
import { DropDownItem, Icon, Modal } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators";
import { withRma } from "MODULES/RMAsAndWarranties/decorators";
import { API_BASE } from "APP_ROOT/constants";
import ExternalLink from "MODULES/shared/components/ExternalLink/ExternalLink";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Close, Header } from "MODULES/shared/components/Modal";
import Form from "./Form";

export const PDF_TYPES = {
  damage: {
    label: "RMA Request for Damage"
  },
  discrepancy: {
    label: "RMA Request for Discrepancy"
  },
  insufficient_trace: {
    label: "RMA Request for Insufficient Trace"
  },
  ber: {
    label: "RMA Request for BER"
  },
  credit: {
    label: "RMA Request for Credit"
  },
  warranty: {
    label: "RMA Request for Warranty Consideration"
  },
  credit_warranty: {
    label: "RMA Request for Credit and Warranty Consideration"
  }
};

export function PrintRma({ pdfType, rma }) {
  const initialValues = { rma_discrepancy: rma.get("rma_discrepancy") };
  const url =
    rma.get("type") === "CustomerRma"
      ? `${API_BASE}/customer_rmas/${rma.get(
          "id"
        )}/download_customer_rma_request_form?type=${pdfType}`
      : `${API_BASE}/vendor_rmas/${rma.get(
          "id"
        )}/download_vendor_rma_request_form?type=${pdfType}`;

  if (pdfType === "discrepancy") {
    return (
      <ToggleSwitch>
        {(visible, open, close) => (
          <DropDownItem onClick={open}>
            <Icon name="file-text-o" fixed />
            &nbsp;Download {PDF_TYPES[pdfType].label}
            <Modal open={visible} close={close} dialogClass="modal-lg">
              <Header>
                <Close close={close} />
                <h4 className="modal-title">Enter Discrepancy Information</h4>
              </Header>
              <Form close={close} initialValues={initialValues} url={url} />
            </Modal>
          </DropDownItem>
        )}
      </ToggleSwitch>
    );
  }

  return (
    <li>
      <ExternalLink url={url}>
        <Icon name="file-text-o" fixed />
        &nbsp;Download {PDF_TYPES[pdfType].label}
      </ExternalLink>
    </li>
  );
}

PrintRma.propTypes = {
  pdfType: T.string.isRequired,
  rma: T.shape({})
};

const isVendorRma = renderIf(
  ({ rma }) =>
    rma.get("type") === "VendorRma" || rma.get("type") === "CustomerRma"
);

export default withRma(isVendorRma(PrintRma));



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Actions/PrintRma.jsx